// Debug wrapper for ActionCable consumer to track disconnections

export function wrapConsumerForDebugging(consumer) {
  if (!consumer || !consumer.connection) return consumer;
  
  const connection = consumer.connection;
  const originalClose = connection.close?.bind(connection);
  const originalDisconnect = connection.disconnect?.bind(connection);
  const originalReopen = connection.reopen?.bind(connection);
  
  // Track close events
  connection.close = function(...args) {
    console.error('🔴 ActionCable connection.close() called:', {
      args,
      stack: new Error().stack,
      readyState: this.webSocket?.readyState,
      isActive: this.isActive()
    });
    return originalClose?.(...args);
  };
  
  // Track disconnect events
  connection.disconnect = function(...args) {
    console.error('🔴 ActionCable connection.disconnect() called:', {
      args,
      stack: new Error().stack,
      readyState: this.webSocket?.readyState,
      reason: args[0]
    });
    return originalDisconnect?.(...args);
  };
  
  // Track reopen events
  connection.reopen = function(...args) {
    console.warn('🔄 ActionCable connection.reopen() called:', {
      args,
      stack: new Error().stack,
      wasActive: this.isActive()
    });
    return originalReopen?.(...args);
  };
  
  // Monitor WebSocket directly
  if (connection.webSocket) {
    const ws = connection.webSocket;
    
    ws.addEventListener('close', (event) => {
      console.error('🔴 WebSocket closed:', {
        code: event.code,
        reason: event.reason,
        wasClean: event.wasClean,
        timestamp: new Date().toISOString()
      });
    });
    
    ws.addEventListener('error', (event) => {
      console.error('⚠️ WebSocket error:', event);
    });
  }
  
  // Monitor connection monitor
  if (connection.monitor) {
    const monitor = connection.monitor;
    const originalStoppedPinging = monitor.stoppedPinging?.bind(monitor);
    const originalStartedPinging = monitor.startedPinging?.bind(monitor);
    const originalPingedAt = monitor.pingedAt?.bind(monitor);
    const originalIsStale = monitor.isStale?.bind(monitor);
    
    monitor.stoppedPinging = function() {
      console.warn('⚠️ ActionCable monitor: Stopped pinging');
      return originalStoppedPinging?.();
    };
    
    monitor.startedPinging = function() {
      console.log('✅ ActionCable monitor: Started pinging');
      return originalStartedPinging?.();
    };
    
    monitor.pingedAt = function(time) {
      console.log('📍 ActionCable monitor: Pinged at', time);
      return originalPingedAt?.(time);
    };
    
    monitor.isStale = function() {
      const result = originalIsStale?.() || false;
      if (result) {
        console.error('🔴 ActionCable monitor: Connection is STALE!', {
          pollInterval: this.pollInterval,
          staleThreshold: this.staleThreshold,
          pingedAt: this.pingedAt
        });
      }
      return result;
    };
  }
  
  console.log('✅ ActionCable consumer wrapped for debugging');
  return consumer;
}